var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.327274 0.328673C0.76364 -0.109558 1.47113 -0.109558 1.90749 0.328673L7.82169 6.26814L13.7359 0.328673C14.1722 -0.109558 14.8797 -0.109558 15.3161 0.328673C15.7525 0.766903 15.7525 1.47742 15.3161 1.91565L9.40191 7.85511L15.3161 13.7946C15.7525 14.2328 15.7525 14.9433 15.3161 15.3816C14.8797 15.8198 14.1722 15.8198 13.7359 15.3816L7.82169 9.44209L1.90749 15.3816C1.47113 15.8198 0.76364 15.8198 0.327274 15.3816C-0.109091 14.9433 -0.109091 14.2328 0.327274 13.7946L6.24147 7.85511L0.327274 1.91565C-0.109091 1.47742 -0.109091 0.766903 0.327274 0.328673Z",
    fill: "#0D0D0D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon_close.f139310ccc86bb593e4ab461b688f2a6.svg";
export { ForwardRef as ReactComponent };